import {
  SortDirectionEnum,
  TerminListApi,
  TerminListPage as TerminListPageGenerated,
} from 'tezaury-frontend-ts-axios';
import { AxiosRequestHeaders } from 'axios';
import { ClientResponse } from '../../model/ClientResponse';
import TerminListPage from '../../model/TerminListPage';
import apiConfiguration from '../configuration/apiConfiguration';
import Uuid from '../../model/Uuid';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new TerminListApi(apiConfiguration(tezauryPrefixPath));

const map = (data: TerminListPageGenerated): TerminListPage => ({
  terminList: data.terminList,
  number: data.number,
  size: data.size,
  totalElements: data.totalElements,
  tezaurus: data.tezaurus,
});

// eslint-disable-next-line import/prefer-default-export
export const fetchTerminPage = async (
  tezaurusUuid?: Uuid,
  hladanyTermin?: string,
  publikovany?: boolean,
  autorPoslednejZmenyUuid?: Uuid,
  page?: number,
  size?: number,
  sortBy?: string,
  sortDirection?: SortDirectionEnum,
  options: { headers?: AxiosRequestHeaders } = {},
):
  Promise<ClientResponse<TerminListPage>> => {
  const {
    data,
    status,
  } = await client.getTerminList(
    tezaurusUuid || '',
    hladanyTermin || '',
    publikovany,
    autorPoslednejZmenyUuid || '',
    page,
    size,
    sortBy,
    sortDirection,
    options,
  );
  return {
    data: map(data),
    responseCode: status,
  };
};
